import { useEffect } from "react";

const SIZE_CLASSES = {
  small: "max-w-[400px]",
  medium: "max-w-[600px]",
  large: "max-w-[800px]",
  xlarge: "max-w-[1000px]",
};

export default function Modal({
  isOpen,
  onClose,
  title,
  children,
  footer,
  size = "medium",
}) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isOpen]);

  if (!isOpen) return null;

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const sizeClass = SIZE_CLASSES[size] ?? SIZE_CLASSES.medium;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4"
      onClick={handleOverlayClick}
    >
      <div
        className={`w-full ${sizeClass} max-h-[90vh] overflow-hidden rounded-(--radius-lg) bg-(--surface-1) shadow-[var(--shadow-popover)] flex flex-col`}
      >
        <div className="flex items-center justify-between border-b border-(--border-subtle) px-6 py-4">
          <h3 className="text-base font-semibold text-(--text-primary)">
            {title}
          </h3>
          <button
            type="button"
            className="cursor-pointer border-0 bg-transparent text-(--text-muted) hover:text-(--text-primary) transition-colors text-2xl leading-none"
            onClick={onClose}
            aria-label="Close"
          >
            &times;
          </button>
        </div>
        <div className="flex-1 overflow-y-auto px-6 py-5">{children}</div>
        {footer && (
          <div className="flex items-center justify-end gap-2 border-t border-(--border-subtle) px-6 py-4">
            {footer}
          </div>
        )}
      </div>
    </div>
  );
}
